import { Injectable, inject } from '@angular/core';
import { ApiService } from '../../Shared/Services/api.service';
import { endpoints } from '../../../../environments/endpoints';
import { LaravelDefaultResponse } from '../../../Interfaces/api/shared/response.interface';
import { TypedResourceRequest } from '../../Shared/Interfaces/api-request.interface';
import {
  AlertSettingsEnvelope,
  AlertSettingsResponse,
} from '../../../Interfaces/api/backoffice/settings.interface';

@Injectable({
  providedIn: 'root',
})
export class AlertSettingsService {
  private readonly _apiService = inject(ApiService);

  settingsRequest(): TypedResourceRequest<LaravelDefaultResponse<AlertSettingsEnvelope>> {
    return this._apiService.get<LaravelDefaultResponse<AlertSettingsEnvelope>>(
      endpoints.backoffice.settings,
      { skipLoading: true, skipError: true },
    );
  }

  toSettings(
    response: LaravelDefaultResponse<AlertSettingsEnvelope> | undefined,
  ): AlertSettingsResponse | null {
    return response?.data?.settings ?? null;
  }
}
